import script from "./AdminStatusBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminStatusBadge.vue?vue&type=script&setup=true&lang=js"

import "./AdminStatusBadge.vue?vue&type=style&index=0&id=10fa8eda&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10fa8eda"]])

export default __exports__